// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

.paint-editor_editor-container_XLFB2 {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
      -ms-flex-direction: column;
          flex-direction: column;
  padding: calc(3 * 0.25rem);
}

.paint-editor_row_ivhGo {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
}

.paint-editor_editor-container-top_bm0Ln {
  border-bottom: 1px dashed var(--paint-ui-pane-border, #d9d9d9);
  padding-bottom: calc(2 * 0.25rem);
}

.paint-editor_top-align-row_mTiEh {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
      -ms-flex-direction: row;
          flex-direction: row;
  height: 100%;
  padding-top: calc(5 * 0.25rem);
  min-width: 524px;
}

.paint-editor_row_ivhGo + .paint-editor_row_ivhGo {
  margin-top: calc(2 * 0.25rem);
}

[dir='ltr'] .paint-editor_mod-dashed-border_lA4GU {
  border-right: 1px dashed var(--paint-ui-pane-border, #d9d9d9);
  padding-right: calc(2 * 0.25rem);
}

[dir='rtl'] .paint-editor_mod-dashed-border_lA4GU {
  border-left: 1px dashed var(--paint-ui-pane-border, #d9d9d9);
  padding-left: calc(2 * 0.25rem);
}

.paint-editor_mod-labeled-icon-height_tymaR {
  height: 2.85rem; /* for the second row so the dashed borders are equal in size */
}

.paint-editor_button-group-button_xpAT3 {
  display: inline-block;
  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  border-radius: 0;
  padding: 0.35rem;
}

[dir='ltr'] .paint-editor_button-group-button_xpAT3 {
  border-left: none;
}

[dir='rtl'] .paint-editor_button-group-button_xpAT3 {
  border-right: none;
}

[dir='ltr'] .paint-editor_button-group-button_xpAT3:last-of-type {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

[dir='ltr'] .paint-editor_button-group-button_xpAT3:first-of-type {
  border-left: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

[dir='rtl'] .paint-editor_button-group-button_xpAT3:last-of-type {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

[dir='rtl'] .paint-editor_button-group-button_xpAT3:first-of-type {
  border-right: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

[dir='ltr'] .paint-editor_button-group-button_xpAT3.paint-editor_mod-start-border__VBgx {
  border-left: 1px solid var(--paint-ui-pane-border, #d9d9d9);
}

[dir='rtl'] .paint-editor_button-group-button_xpAT3.paint-editor_mod-start-border__VBgx {
  border-right: 1px solid var(--paint-ui-pane-border, #d9d9d9);
}

[dir='ltr'].paint-editor_button-group-button_xpAT3.paint-editor_mod-no-end-border_wwa8M {
  border-right: none;
}

[dir='rtl'].paint-editor_button-group-button_xpAT3.paint-editor_mod-no-end-border_wwa8M {
  border-left: none;
}

.paint-editor_button-group-button-icon_rAnYq {
  width: 1.25rem;
  height: 1.25rem;
  vertical-align: middle;
  -webkit-filter: var(--paint-filter-icon-gray, none);
          filter: var(--paint-filter-icon-gray, none);
}

.paint-editor_mod-mode-tools_V7Goy {
  margin-left: calc(2 * 0.25rem);
}

[dir='ltr'] .paint-editor_mod-margin-after_T6vyW {
  margin-right: calc(2 * 0.25rem);
}

[dir='rtl'] .paint-editor_mod-margin-after_T6vyW {
  margin-left: calc(2 * 0.25rem);
}

.paint-editor_controls-container_nA9ih {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-flow: column;
      -ms-flex-flow: column;
          flex-flow: column;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  margin-left: calc(2 * 0.25rem);
  margin-right: calc(2 * 0.25rem);
}

.paint-editor_canvas-container_s1neX {
  width: 100%;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  min-width: 402px; /* Leave room for the border */
  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);
  border-radius: 0.25rem;
  position: relative;
  overflow: visible;
}

.paint-editor_mode-selector_ptRkc {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 7.5rem;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
          flex-wrap: wrap;
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-align-content: flex-start;
      -ms-flex-line-pack: start;
          align-content: flex-start;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.paint-editor_zoom-controls_LWaTW {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -webkit-flex-direction: row-reverse;
      -ms-flex-direction: row-reverse;
          flex-direction: row-reverse;
}

.paint-editor_color-picker-wrapper__9F_b {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.paint-editor_canvas-controls_reig3 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 36px;
  margin-top: 0.25rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.paint-editor_bitmap-button__J7lF {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  border-radius: 5px;
  background-color: var(--paint-looks-secondary, #855cd6);
  padding: calc(2 * 0.25rem);
  line-height: 1.5rem;
  font-size: calc(3 * 0.25rem);
  font-weight: bold;
  color: white;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
      -ms-flex-pack: center;
          justify-content: center;
}

[dir='ltr'] .paint-editor_bitmap-button-icon_XkO72 {
  margin-right: calc(2 * 0.25rem);
}

[dir='rtl'] .paint-editor_bitmap-button-icon_XkO72 {
  margin-left: calc(2 * 0.25rem);
}

@media only screen and (max-width: 1256px) {
  .paint-editor_editor-container_XLFB2 {
    padding: calc(3 * 0.25rem) 0.25rem;
  }

  .paint-editor_mode-selector_ptRkc {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
        -ms-flex-pack: start;
            justify-content: flex-start;
  }

  .paint-editor_controls-container_nA9ih {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
}

.paint-editor_text-area_EcHCp {
  color: black;
  background: transparent;
  border: none;
  display: none;
  margin: 0px;
  opacity: 0.8;
  outline: none;
  overflow: hidden;
  padding: 0px;
  position: absolute;
  resize: none;
  -webkit-text-fill-color: transparent;
  text-fill-color: transparent;
}

.paint-editor_button-text_qkEL8 {
  width: 100%; /* Fixes button text wrapping in Edge */
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/paint-editor/paint-editor.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;MAC1B,0BAA0B;UACtB,sBAAsB;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;MACvB,uBAAuB;UACnB,mBAAmB;EAC3B,yBAAyB;EACzB,2BAA2B;MACvB,sBAAsB;UAClB,mBAAmB;AAC7B;;AAEA;EACE,8DAA8D;EAC9D,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;MACvB,uBAAuB;UACnB,mBAAmB;EAC3B,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,4DAA4D;EAC5D,+BAA+B;AACjC;;AAEA;EACE,eAAe,EAAE,+DAA+D;AAClF;;AAEA;EACE,qBAAqB;EACrB,sDAAsD;EACtD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,2DAA2D;EAC3D,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,4DAA4D;EAC5D,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,mDAAmD;UAC3C,2CAA2C;AACrD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,mBAAmB;EACnB,oBAAoB;MAChB,oBAAoB;UAChB,YAAY;EACpB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;MAChB,oBAAoB;UAChB,YAAY;EACpB,gBAAgB,EAAE,8BAA8B;EAChD,sDAAsD;EACtD,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;MACvB,uBAAuB;UACnB,mBAAmB;EAC3B,uBAAuB;MACnB,mBAAmB;UACf,eAAe;EACvB,wBAAwB;EACxB,+BAA+B;MAC3B,qBAAqB;UACjB,uBAAuB;EAC/B,iCAAiC;MAC7B,yBAAyB;UACrB,yBAAyB;EACjC,yBAAyB;EACzB,sCAAsC;MAClC,sBAAsB;UAClB,8BAA8B;AACxC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mCAAmC;MAC/B,+BAA+B;UAC3B,2BAA2B;AACrC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;MAClC,sBAAsB;UAClB,8BAA8B;AACxC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,uDAAuD;EACvD,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;MAC3B,qBAAqB;UACjB,uBAAuB;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;QAC1B,0BAA0B;YACtB,sBAAsB;IAC9B,uBAAuB;IACvB,mCAAmC;QAC/B,oBAAoB;YAChB,2BAA2B;EACrC;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,WAAW,EAAE,uCAAuC;EACpD,mBAAmB;AACrB","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n.editor-container {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: calc(3 * 0.25rem);\n}\n\n.row {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.editor-container-top {\n  border-bottom: 1px dashed var(--paint-ui-pane-border, #d9d9d9);\n  padding-bottom: calc(2 * 0.25rem);\n}\n\n.top-align-row {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  height: 100%;\n  padding-top: calc(5 * 0.25rem);\n  min-width: 524px;\n}\n\n.row + .row {\n  margin-top: calc(2 * 0.25rem);\n}\n\n[dir='ltr'] .mod-dashed-border {\n  border-right: 1px dashed var(--paint-ui-pane-border, #d9d9d9);\n  padding-right: calc(2 * 0.25rem);\n}\n\n[dir='rtl'] .mod-dashed-border {\n  border-left: 1px dashed var(--paint-ui-pane-border, #d9d9d9);\n  padding-left: calc(2 * 0.25rem);\n}\n\n.mod-labeled-icon-height {\n  height: 2.85rem; /* for the second row so the dashed borders are equal in size */\n}\n\n.button-group-button {\n  display: inline-block;\n  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  border-radius: 0;\n  padding: 0.35rem;\n}\n\n[dir='ltr'] .button-group-button {\n  border-left: none;\n}\n\n[dir='rtl'] .button-group-button {\n  border-right: none;\n}\n\n[dir='ltr'] .button-group-button:last-of-type {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n[dir='ltr'] .button-group-button:first-of-type {\n  border-left: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n[dir='rtl'] .button-group-button:last-of-type {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n[dir='rtl'] .button-group-button:first-of-type {\n  border-right: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n[dir='ltr'] .button-group-button.mod-start-border {\n  border-left: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n}\n\n[dir='rtl'] .button-group-button.mod-start-border {\n  border-right: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n}\n\n[dir='ltr'].button-group-button.mod-no-end-border {\n  border-right: none;\n}\n\n[dir='rtl'].button-group-button.mod-no-end-border {\n  border-left: none;\n}\n\n.button-group-button-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  vertical-align: middle;\n  -webkit-filter: var(--paint-filter-icon-gray, none);\n          filter: var(--paint-filter-icon-gray, none);\n}\n\n.mod-mode-tools {\n  margin-left: calc(2 * 0.25rem);\n}\n\n[dir='ltr'] .mod-margin-after {\n  margin-right: calc(2 * 0.25rem);\n}\n\n[dir='rtl'] .mod-margin-after {\n  margin-left: calc(2 * 0.25rem);\n}\n\n.controls-container {\n  width: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-flow: column;\n      -ms-flex-flow: column;\n          flex-flow: column;\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  margin-left: calc(2 * 0.25rem);\n  margin-right: calc(2 * 0.25rem);\n}\n\n.canvas-container {\n  width: 100%;\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  min-width: 402px; /* Leave room for the border */\n  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n  border-radius: 0.25rem;\n  position: relative;\n  overflow: visible;\n}\n\n.mode-selector {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 7.5rem;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -webkit-align-content: flex-start;\n      -ms-flex-line-pack: start;\n          align-content: flex-start;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.zoom-controls {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -webkit-flex-direction: row-reverse;\n      -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse;\n}\n\n.color-picker-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.canvas-controls {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 36px;\n  margin-top: 0.25rem;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.bitmap-button {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  border-radius: 5px;\n  background-color: var(--paint-looks-secondary, #855cd6);\n  padding: calc(2 * 0.25rem);\n  line-height: 1.5rem;\n  font-size: calc(3 * 0.25rem);\n  font-weight: bold;\n  color: white;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n[dir='ltr'] .bitmap-button-icon {\n  margin-right: calc(2 * 0.25rem);\n}\n\n[dir='rtl'] .bitmap-button-icon {\n  margin-left: calc(2 * 0.25rem);\n}\n\n@media only screen and (max-width: 1256px) {\n  .editor-container {\n    padding: calc(3 * 0.25rem) 0.25rem;\n  }\n\n  .mode-selector {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: start;\n    -webkit-justify-content: flex-start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n  }\n\n  .controls-container {\n    margin-right: 0.25rem;\n    margin-left: 0.25rem;\n  }\n}\n\n.text-area {\n  color: black;\n  background: transparent;\n  border: none;\n  display: none;\n  margin: 0px;\n  opacity: 0.8;\n  outline: none;\n  overflow: hidden;\n  padding: 0px;\n  position: absolute;\n  resize: none;\n  -webkit-text-fill-color: transparent;\n  text-fill-color: transparent;\n}\n\n.button-text {\n  width: 100%; /* Fixes button text wrapping in Edge */\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor-container": `paint-editor_editor-container_XLFB2`,
	"editorContainer": `paint-editor_editor-container_XLFB2`,
	"row": `paint-editor_row_ivhGo`,
	"editor-container-top": `paint-editor_editor-container-top_bm0Ln`,
	"editorContainerTop": `paint-editor_editor-container-top_bm0Ln`,
	"top-align-row": `paint-editor_top-align-row_mTiEh`,
	"topAlignRow": `paint-editor_top-align-row_mTiEh`,
	"mod-dashed-border": `paint-editor_mod-dashed-border_lA4GU`,
	"modDashedBorder": `paint-editor_mod-dashed-border_lA4GU`,
	"mod-labeled-icon-height": `paint-editor_mod-labeled-icon-height_tymaR`,
	"modLabeledIconHeight": `paint-editor_mod-labeled-icon-height_tymaR`,
	"button-group-button": `paint-editor_button-group-button_xpAT3`,
	"buttonGroupButton": `paint-editor_button-group-button_xpAT3`,
	"mod-start-border": `paint-editor_mod-start-border__VBgx`,
	"modStartBorder": `paint-editor_mod-start-border__VBgx`,
	"mod-no-end-border": `paint-editor_mod-no-end-border_wwa8M`,
	"modNoEndBorder": `paint-editor_mod-no-end-border_wwa8M`,
	"button-group-button-icon": `paint-editor_button-group-button-icon_rAnYq`,
	"buttonGroupButtonIcon": `paint-editor_button-group-button-icon_rAnYq`,
	"mod-mode-tools": `paint-editor_mod-mode-tools_V7Goy`,
	"modModeTools": `paint-editor_mod-mode-tools_V7Goy`,
	"mod-margin-after": `paint-editor_mod-margin-after_T6vyW`,
	"modMarginAfter": `paint-editor_mod-margin-after_T6vyW`,
	"controls-container": `paint-editor_controls-container_nA9ih`,
	"controlsContainer": `paint-editor_controls-container_nA9ih`,
	"canvas-container": `paint-editor_canvas-container_s1neX`,
	"canvasContainer": `paint-editor_canvas-container_s1neX`,
	"mode-selector": `paint-editor_mode-selector_ptRkc`,
	"modeSelector": `paint-editor_mode-selector_ptRkc`,
	"zoom-controls": `paint-editor_zoom-controls_LWaTW`,
	"zoomControls": `paint-editor_zoom-controls_LWaTW`,
	"color-picker-wrapper": `paint-editor_color-picker-wrapper__9F_b`,
	"colorPickerWrapper": `paint-editor_color-picker-wrapper__9F_b`,
	"canvas-controls": `paint-editor_canvas-controls_reig3`,
	"canvasControls": `paint-editor_canvas-controls_reig3`,
	"bitmap-button": `paint-editor_bitmap-button__J7lF`,
	"bitmapButton": `paint-editor_bitmap-button__J7lF`,
	"bitmap-button-icon": `paint-editor_bitmap-button-icon_XkO72`,
	"bitmapButtonIcon": `paint-editor_bitmap-button-icon_XkO72`,
	"text-area": `paint-editor_text-area_EcHCp`,
	"textArea": `paint-editor_text-area_EcHCp`,
	"button-text": `paint-editor_button-text_qkEL8`,
	"buttonText": `paint-editor_button-text_qkEL8`
};
export default ___CSS_LOADER_EXPORT___;
